export default __webpack_public_path__ + "static/media/Down-club.0e99489c.png";